import { LOADING_SCREEN_START_TIME } from './data-types/local-storage/localStorageConstants';
import './index.css';
import reportHandler from './reportHandler';
import reportWebVitals from './reportWebVitals';
import { checkVersion } from './services/cacheBuster';
import * as serviceWorker from './serviceWorker';

serviceWorker.register();
serviceWorker.setUpFavicons();
serviceWorker.addManifestFile();

let starting = true;

if (starting) {
  import('./loadingRenderer').then(() => {
    localStorage.setItem(LOADING_SCREEN_START_TIME, new Date().getTime().toString());
  });
}

checkVersion();

import('./appStarter').then(() => {
  starting = false;
});

reportWebVitals(reportHandler);
